import React, { MouseEvent, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import CartIcon from '../../../../ui/svg/shopping-cart/cart';
import TopMiniCartDropPanel from './drop-panel';
import { CLOSE_SEARCH_D_EVENT } from '../../search-desktop/ui/main';
import { CLOSE_HEADER_ACCOUNT_EVENT } from '../../account/ui/main';
import { IStoreProps } from '../index';
import { sendGAEvent } from '../../../../domain/marketing/gtm-provider';

export const UPDATE_MINI_CART_COUNT_EVENT = 'UPDATE_MINI_CART_COUNT_EVENT';
export const CLOSE_MINI_CART_EVENT = 'CLOSE_MINI_CART_EVENT';
export const UPDATE_COUNT_VALUE_ONLY_EVENT = 'UPDATE_COUNT_VALUE_ONLY_EVENT';

interface ITopMiniCart {
    isMobile: boolean;
    storeProps: IStoreProps;
}

const TopMiniCart = (props: ITopMiniCart) => {

    const { isMobile, storeProps } = props;
    const { useAppSelector, rootActions } = storeProps;

    const dispatch = useDispatch();
    // @ts-ignore
    const isOpened = useAppSelector(store => store.root.isOpened);
    // @ts-ignore
    const count = useAppSelector(store => store.root.count);

    // ------------------ OPEN / CLOSE ----------------------
    const toggle = () => {

        dispatch(rootActions.main({
            isOpened: !isOpened,
            showNewUserPopup: false,
            isLoading: true,
        }));

        // close account and desktop search
        document.dispatchEvent(new CustomEvent(CLOSE_SEARCH_D_EVENT));
        document.dispatchEvent(new CustomEvent(CLOSE_HEADER_ACCOUNT_EVENT));

        if(!isOpened){
            sendGAEvent('Top Mini Cart', 'Open Panel');
        }
    };

    const close = useCallback(() => {
        dispatch(
            rootActions.main({
                isOpened: false,
                showNewUserPopup: false,
                isLoading: true,
            })
        )
    }, [dispatch, rootActions]);

    /**
     * handle click outside
     */
    useEffect(() => {

        document.addEventListener('click', close);

        return () => {
            document.removeEventListener('click', close);
        };
    }, [close]);

    /**
     * Update count from outside.
     */
    useEffect(() => {

        const updateCount = (evt: CustomEvent) => {

            const count = evt.detail || 0;

            dispatch(
                rootActions.main({
                    count,
                })
            );
        };

        // @ts-ignore
        document.addEventListener(UPDATE_COUNT_VALUE_ONLY_EVENT, updateCount);

        return () => {
            // @ts-ignore
            document.removeEventListener(UPDATE_COUNT_VALUE_ONLY_EVENT, updateCount);
        };
    }, [
        dispatch,
        rootActions,
    ]);

    /**
     * Close mini-cart from outside.
     */
    useEffect(() => {
        document.addEventListener(CLOSE_MINI_CART_EVENT, close);

        return () => {
            document.removeEventListener(CLOSE_MINI_CART_EVENT, close);
        };
    }, [dispatch, close]);

    const stopPropagation = (evt: MouseEvent) => {
        evt.stopPropagation();
    };

    // ------------------------------------------------------

    return (
        <div className={ `flex items-center relative ${ isMobile ? 'justify-center h-full mr-1' : '' }` } onClick={ stopPropagation }>
            <button
                type="button"
                onClick={ toggle }
                className="flex items-center justify-center relative mr-4">
                <div className="top-mini-cart-count absolute bg-blue-200 rounded-full flex items-center justify-center text-white">{ count }</div>
                <CartIcon width="20" color="#F8F9FB" style={{
                    marginTop: '2px',
                }} />
            </button>

            { isOpened && <TopMiniCartDropPanel storeProps={ storeProps } /> }
        </div>
    )
};

export default TopMiniCart;